import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { BikeShopPostsService } from '../../../../../../services/bike-shop-posts.service';
import { HelpersService } from '../../../../../../services/helpers.service';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-communication',
  templateUrl: './create-communication.component.html',
  styleUrls: ['./create-communication.component.scss'],
})
export class CreateCommunicationComponent implements OnInit {
  @Input() post;
  @Input() partnerID;
  public postForm: FormGroup;
  public partnerName: string;
  public partnerLogo: string;
  public images: any = [];
  public saving: boolean = false;

  constructor(
    public modal: NgbActiveModal,
    private fb: FormBuilder,
    public postsService: BikeShopPostsService,
    private helpersService: HelpersService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.partnerName = this.helpersService.getPartnerData().Name;
    this.partnerLogo = this.helpersService.getPartnerData().ImageURL;
    this.createFrom();
  }

  createFrom() {
    this.images = this.post ? this.post.postMedia : [];
    this.postForm = this.fb.group({
      content: new FormControl(
        this.post ? this.post.content : '',
        Validators.required,
      ),
      externalLink: new FormControl(
        this.post && this.post.externalLink ? this.post.externalLink : '',
        Validators.nullValidator,
      ),
    });
  }

  async myUploader(event) {
    if (event.target.files && event.target.files.length > 0) {
      for (var i = 0; i < event.target.files.length; i++) {
        var file = event.target.files[i];
        var data = await this.readFileAsync(file);
        console.log(file);
        this.images.push({
          mediaURL: data,
          mediaType: file.type,
        });
      }
    }
  }

  readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result.toString());
      };
      reader.onerror = reject;
    });
  }

  removeImage(index) {
    this.images.splice(index, 1);
  }

  deletePost() {
    this.saving = true;
    this.confirmationService.confirm({
      key: 'delete_post',
      acceptLabel: this.translate.instant('general.ok'),
      rejectLabel: this.translate.instant('general.no'),
      message: this.translate.instant('bikeshop.posts.delete_confirm'),
      accept: () => {
        this.postsService.deletePost(this.post.id).subscribe((result) => {
          this.modal.close('deleted');
        });
      },
      reject: () => {
        this.saving = false;
      },
    });
  }

  send(value) {
    this.saving = true;

    if (this.post && this.post.id !== null) {
      const postObj = {
        ...this.post,
        content: value.content,
        externalLink: value.externalLink,
        postMedia: this.images,
      };
      this.postsService.updatePost(postObj).subscribe(
        (res) => {
          this.modal.close('Updated');
        },
        (error) => {
          this.saving = false;
        },
      );
    } else {
      const postObj = {
        PartnerID: this.partnerID,
        Content: value.content,
        ExternalLink: value.externalLink,
        PostMedia: this.images,
      };
      this.postsService.createPost(postObj).subscribe(
        (res) => {
          this.modal.close('Created');
        },
        (error) => {
          this.saving = false;
        },
      );
    }
  }
}
